import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const passengerRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./management/PassengerManagementRoute').then((m) => ({
        Component: m.PassengerManagementRoute,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/passengers"
        linkText="Go back to passengers"
      />
    ),
  },
];
